// extracted by mini-css-extract-plugin
export default {"ConfirmationDialog_text":"webpack-pages-DataExtraction-QualityAssessmentTemplate-QaConfirmationDialog-module__ConfirmationDialog_text"};